import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  TextField,
  InputAdornment
} from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link as RouterLink, useNavigate, useLocation, useParams } from 'react-router-dom'
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import cssVariables from "../../../../theme/cssVariables";
import dayjs from 'dayjs'

import { getGoalForEdit, getGroupCategory, postAddMembers } from "../../../../actions/corporateGoal";

import Search from "@mui/icons-material/Search";
import { ReactComponent as PlusIcon } from "../../../../icons/plus.svg";
import MemberTable from "../../../../components/corporateGoal/MemberTable";
import ConfirmAddMemberDialog from "../../../../components/corporateGoal/ConfirmAddMemberDialog";
import SimpleDialog from "../../../../components/SimpleDialog";

const useStyles = makeStyles({
  searchSvg: {
    "& > path": {
      fill: "#C4C4C4",
    },
  },
  plusSvg: {
    "& > path": {
      fill: "#fff",
      stroke: "#fff",
    },
  },
})

const MembersGoalAlignment = (props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const classes = useStyles()
  const navigate = useNavigate()
  const { state } = useLocation()
  const { serial } = useParams()
  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
  }
  const [cycleSerial, setCycleSerial] = React.useState("")
  const [search, setSearchValue] = React.useState("")
  const handleSearch = (event) => {
    setSearchValue(event.target.value);
  }

  const [confirmDialog, setOpenConfirmDialog] = React.useState(false)
  const handleOpenConfirmDialog = () => {
    setOpenConfirmDialog(true)
  }

  const goto = (route) => {
    navigate("/admin" + route, { replace: false })
  }

  const [list, setList] = React.useState([])
  const handleMemberList = (data) => {
    setList(data)
  }

  const [totalSelected, setTotalSelected] = React.useState(0)
  const [selectedList, setSelectedList] = React.useState([])

  const [preSelectedDetail, setPreSelectedDetail] = React.useState({})
  const [goalDetail, setGoalDetail] = React.useState({})
  const [goalCategoryOptions, setGoalCategoryOptions] = React.useState([])
  const [openSuccessAddMember, setOpenSuccessAddMember] = React.useState(false)


  // useEffect
  useEffect(() => {
    dispatch(getGoalForEdit(serial))
      .then(resp => {
        if (resp?.data?.goal_detail?.goal_category && resp?.data?.goal_detail?.goal_member) {
          setPreSelectedDetail({ goalCategory: resp.data.goal_detail.goal_category, currentMembers: resp.data.goal_detail.goal_member?.members })
        }
        setGoalDetail(resp?.data?.goal_detail)
        setCycleSerial(resp?.data?.goal_detail?.cycle_id)
        dispatch(getGroupCategory(resp?.data?.goal_detail?.cycle_id))
          .then(resp => {
            setGoalCategoryOptions(resp.data.goalCategory);
          })
      })
  }, [])


  const prepareValuesBeforeAdd = (members) => {
    var data = {
      goal_detail: {
        goal_name: goalDetail?.goal_detail?.goal_name,
        goal_details: goalDetail?.goal_detail?.goal_details,
        start_date: dayjs(goalDetail?.goal_detail?.start_date).format('YYYY-MM-DD'),
        end_date: dayjs(goalDetail?.goal_detail?.end_at).format('YYYY-MM-DD'),
        goal_metric: goalDetail?.goal_detail?.goal_metric,
        target_condition: goalDetail?.goal_detail?.target_condition?.toLowerCase() || "",
        unit: goalDetail?.goal_detail?.unit || "",
        specify_unit: goalDetail?.goal_detail?.specify_unit || "",
        target_value: goalDetail?.goal_detail?.target_value,
      },
      goal_category: {
        kpi_goal_template_category_id: goalDetail?.goal_category?.kpi_goal_template_category_id,
        evaluation_weight: goalDetail?.goal_category?.evaluation_weight.toString(),
      },
      goal_type: goalDetail?.goal_type || "",
      suggestion_type: goalDetail?.suggestion_type || "",
      goal_template_id: goalDetail?.goal_template_id || "",
      goal_master_id: goalDetail?.goal_master_id || "",
      kpi_form_evaluate_id: goalDetail?.kpi_form_evaluate_id || "",
      goal_member: {
        add: members.length > 0 ? members : undefined,
      },
      kpi_form_id: goalDetail?.kpi_form_id,
      update_data: {
        goal_serial: goalDetail?.kpi_goal_id,
        goal_form_serial: serial
      }
    }
    dispatch(postAddMembers(serial, data))
      .then(resp => {
        if (resp?.success) {
          setOpenSuccessAddMember(true);
        }
      })
  }

  const handleAddMembers = (memberList) => {
    const members = memberList.map((item) => {
      if (!item.goalCategoryDetail) {
        return { member_id: item?.memberSerial ?? undefined, template_category_id: item?.selectCategory ?? undefined, goal_id: goalDetail?.kpi_goal_id, form_goal_id: undefined, form_evaluate_id: item?.memberFormEvaluate }
      }
    })
    prepareValuesBeforeAdd(members)
  }

  const handleSuccessAddMember = (value) => {
    setOpenSuccessAddMember(value)
    goto(`/manage-corporate-goal/${serial}`)
  }


  return (
    <>
      <Helmet>
        <title>Goal Alignment - Add Members | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => navigate('/kpi/home', { replace: false })}>
                {t('label.home')}
              </span> /
              <span style={styles.link} onClick={() => goto('/manage-corporate-goal')}>
                {` ${t('corporateGoal.label.title')}`}
              </span> /
              <span style={styles.link} onClick={() => goto(`/manage-corporate-goal/${serial}`)}>
                {` ${t('corporateGoal.label.goalAlignment')}`}
              </span> /
              <span style={styles.end} >
                {` ${t('corporateGoal.label.addMembers')}`}
              </span>
            </Typography>
          </Grid>
          <Grid container spacing={2} mt={1} mb={2}>
            <Grid item>
              <Typography variant="h1" fontSize={36} lineHeight="39.6px" fontWeight="500" color="#404349">
                {/* {t("home.label.latestInbox")} */}
                {t("corporateGoal.label.addMembers")}
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item sm={12} xs={12} md={4} mr="auto">
              <TextField
                id="input-with-icon-textfield"
                fullWidth
                placeholder={t("corporateGoal.label.searchMember")}
                size="small"
                sx={{ background: "#fff", borderColor: "#E5E5E5" }}
                className="searchTextField-h48"
                value={search}
                onChange={handleSearch}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search className={classes.searchSvg} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid
              item
              xs="auto"
              sm="auto"
              md="auto"
              lg="auto"
              display="flex"
              alignItems="flex-start"
              flexDirection="row-reverse"
              ml={2}
            >
              <Button
                size="small"
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={() => handleOpenConfirmDialog()}
                disabled={totalSelected < 1}
                color="primary"
                variant="contained"
                sx={{
                  width: "179px",
                  height: "45px",
                  p: "0",
                  textTransform: "none",
                }}
              >
                <PlusIcon className={classes.plusSvg} />
                <Typography ml={1} fontSize="18px" sx={{ color: "#FFF!important" }}>{t("corporateGoal.label.addMember")}</Typography>
              </Button>

              <Box sx={{ width: "220px", height: "45px", borderRadius: "5px", background: "#EFF6F4", mr: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Typography color="#5DA196" fontSize="18px" fontWeight="400" >{t("corporateGoal.label.selectedEmployees")} : {totalSelected} </Typography>
              </Box>
            </Grid>
          </Grid>
          <MemberTable search={search} preSelected={preSelectedDetail} returnTotalSelectedNumber={setTotalSelected} returnList={handleMemberList} returnSelectedList={setSelectedList} cycleSerial={cycleSerial} goal={goalDetail?.kpi_goal_id} />
          <ConfirmAddMemberDialog open={confirmDialog} setDialogValue={setOpenConfirmDialog} memberList={list} selectedList={selectedList} preSelectedCategory={preSelectedDetail?.goalCategory ?? ""} goalCategoryOptions={goalCategoryOptions} formSubmit={handleAddMembers} />

          <SimpleDialog open={openSuccessAddMember} setValue={handleSuccessAddMember} text={t("corporateGoal.label.dialog.addMemberSuccess")} title={t("label.success")} subTitle="" />
        </Container>
      </Box>
    </>
  );
};
export default MembersGoalAlignment;
